<section class="header-section"
    [ngStyle]="{'background-image': !mobileSize ? 'url(' + actualCampaignImage + ')' : 'unset'}"
    [ngClass]="{'margin-breadcrumb': !isApp}">
    <div class="header-shadow"></div>
    <div class="flex-column flex-wdgt-row d-none d-wdgt-flex wrapper-header">
        <ng-container *ngIf="!isApp">
            <a (click)="showContractList(true)" class="btn-contract-list pt-6 d-wdgt-none">
                <span class="d-flex flex-row position-relative">
                    <div>
                        <span class="d-inline-block align-middle">
                            {{ contract?.supplyCity | uppercase }}
                        </span>
                        <span class="position-absolute ml-1">
                            <i class="mt-n1 font-weight-bold icon-edponline-Bop-073 rotate-270" aria-hidden="true"></i>
                        </span>
                    </div>

                    <span class="subtitle text-truncate">{{ "pt.edp.edponline.contract.consumption.local.select" | translate }}</span>
                </span>
            </a>
        </ng-container>

        <div class="header-content w-100" [ngClass]="{'hide-dots': !isCollapsed}">
            <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig"
            (beforeChange)="afterChange($event)">
                <div ngxSlickItem *ngFor="let campaign of campaigns; trackBy trackCampaign; first as isFirst" class="slide">
                    <div class="campaign-content d-flex flex-column">                        
                        <span class="title d-block" [ngStyle]="{'color': !mobileSize ? campaign.titleColorDesktop : campaign.titleColorMobile }">{{ campaign.name }}</span>
                        <span
                            class="description"
                            id="dashboard-banner-description"
                            [ngClass]="{ 'description-hide': !isCollapsed }"
                            [innerHTML]="campaign.description"
                            (click)="isCollapsed && showCampaignDetails(campaign)"
                        ></span>
                        <a (click)="showCampaignDetails(campaign)" class="d-none d-wdgt-block link edp-text-seaweed-green">
                             {{ "pt.edp.edponline.dashboard.header.co2.counter.link.title" | translate }}
                            <span>
                                <i class="icon-edponline-Bop-073 rotate-270 font-weight-bold" aria-hidden="true"></i>
                            </span>
                        </a>
                    </div>
                </div>
            </ngx-slick-carousel>

            <span class="d-block text-center d-wdgt-none collapse-btn" (click)="isCollapsed = !isCollapsed">
                <i class="icon-2x icon-edponline-Bop-073 cursor-pointer" [ngClass]="{ 'rotate-180': isCollapsed }" aria-hidden="true"></i>
            </span>
        </div>
    </div>

    <div class="alert-message flex-column flex-wdgt-row campaign-slider d-block">
        <div class="d-flex flex-column position-relative ml-3">
            <p [innerHTML]="'pt.edp.edponline.dashboard.header.alert.message' | translate"></p>
        </div>
    </div>

    <div class="flex-column flex-wdgt-row campaign-slider d-block d-wdgt-none">
        <ng-container *ngIf="!isApp">
            <a (click)="showContractList(true)" class="btn-contract-list pt-6 d-wdgt-none">
                <span class="d-flex flex-column position-relative ml-3">
                    <div>
                        <span class="d-inline-block align-middle">
                            {{ contract?.supplyProvince | uppercase }}
                        </span>
                        <span class="position-absolute ml-1">
                            <i class="mt-n1 font-weight-bold icon-edponline-Bop-073 rotate-270" aria-hidden="true"></i>
                        </span>
                    </div>

                    <span class="subtitle text-truncate">{{ "pt.edp.edponline.contract.consumption.local.select" | translate }}</span>
                </span>
            </a>
        </ng-container>
        <ngx-slick-carousel class="carousel" #slickModalMobile="slick-carousel" [config]="slideConfig" >
            <div ngxSlickItem *ngFor="let campaign of campaigns; trackBy: trackCampaign; first as isFirst" class="slide">
                <div
                    class="edp-card-widget-gradient card campaign-content mt-2 d-flex flex-column"
                    (click)="showCampaignDetails(campaign)"
                >
                    <div
                        class="d-flex flex-column card-image-collective-challenge"
                        [ngStyle]="{
                            'background-image': 'url(' + setSliderImages(campaign) + ')' }"
                    ></div>
                    <div class="card-header h-auto">
                        <span class="card-title w-auto" [ngStyle]="{'color': campaign.titleColorMobile }">
                            {{ campaign.name | translate }}
                        </span>
                    </div>
                    <div class="campaign-body">
                        <span class="description" [innerHTML]="campaign.description"></span>
                    </div>
                </div>
            </div>
        </ngx-slick-carousel>
    </div>
</section>
